import { Component, OnInit } from '@angular/core';

import { Router, Route, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {

  image: any = require("../image/error500.png");

  constructor(private router: Router) { }

  ngOnInit() {
  }
}
